import { FormView } from '../../UI/view/form-view';
import { FormItemType } from '../../UI/view/component-map';
import { initView } from '../../UI/view/view';
import { SavedOrdersList } from './saved-orders-list';
import { CurrentOrdersList } from './current-orders-list';
import { AllOrdersList } from './all-orders-list';
import { RecentlyShippedOrdersList } from './recently-shipped-orders-list';
import { CanceledOrdersList } from './canceled-orders-list';
import { CustomerChangedOrdersList } from './customer-changed-orders-list';
import { MyRecentOrdersList } from './my-recent-orders-list';
import { ordersDataSource, ordersPermissions } from './orders-datasource';

// Rows the grid shows after its filters + search; badged tabs stay mounted so it stays live.
const filteredCount = (state, dsName: string) => state[dsName]?.filteredTotal ?? 0;

export const ordersView = {
  pageHeader: 'Orders',
  permissions: ordersPermissions,
  breadcrumbs: [ { name: 'Orders', icon: 'bag', to: '/orders' } ],
  editMode: false,
  items: [
    {
      type: FormItemType.tab,
      name: 'ordersTabs',
      items: [
        {
          label: 'Saved Orders Pending Placement',
          mountOnEnter: false,
          badgeCounter: (state) => filteredCount(state, 'savedOrders'),
          badgeColor: () => 'secondary',
          items: [
            {
              type: FormItemType.customComponent,
              component: SavedOrdersList,
              name: 'savedOrdersList'
            }
          ]
        },
        {
          label: 'Approved Orders Updated by Customers in CAS',
          mountOnEnter: false,
          badgeCounter: (state) => filteredCount(state, 'customerChangedOrders'),
          badgeColor: () => 'secondary',
          items: [
            {
              type: FormItemType.customComponent,
              component: CustomerChangedOrdersList,
              name: 'customerChangedOrdersList'
            }
          ]
        },
        {
          label: 'My Recently Changed Orders',
          mountOnEnter: false,
          badgeCounter: (state) => filteredCount(state, 'myRecentOrders'),
          badgeColor: () => 'secondary',
          items: [
            {
              type: FormItemType.customComponent,
              component: MyRecentOrdersList,
              name: 'myRecentOrdersList'
            }
          ]
        },
        {
          label: 'Current Orders',
          items: [
            {
              type: FormItemType.customComponent,
              component: CurrentOrdersList,
              name: 'currentOrdersList'
            }
          ]
        },
        {
          label: 'Recently Shipped Orders',
          mountOnEnter: false,
          badgeCounter: (state) => filteredCount(state, 'recentlyShippedOrders'),
          badgeColor: () => 'secondary',
          items: [
            {
              type: FormItemType.customComponent,
              component: RecentlyShippedOrdersList,
              name: 'recentlyShippedOrdersList'
            }
          ]
        },
        {
          label: 'Canceled Orders',
          mountOnEnter: false,
          badgeCounter: (state) => filteredCount(state, 'canceledOrders'),
          badgeColor: () => 'secondary',
          items: [
            {
              type: FormItemType.customComponent,
              component: CanceledOrdersList,
              name: 'canceledOrdersList'
            }
          ]
        },
        {
          label: 'All Orders',
/*           badgeCounter: (state) => state.allOrders?.total ?? 0,
          badgeColor: () => 'secondary', */
          items: [
            {
              type: FormItemType.customComponent,
              component: AllOrdersList,
              name: 'allOrdersList'
            }
          ]
        }
      ]
    }
  ]
} as FormView;

export const OrdersMain = initView({ form: ordersView, dataSource: ordersDataSource });
